import { AppIcon, RawSVG } from '../icon.type';

export const iconWithdrawal: AppIcon = {
  svgData: process.env.ICON_WITHDRAWAL as RawSVG,
  name: 'withdrawal',
};
